export const aciTouristAssistance = {
    iconName: 'tourist-assistance',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        g: {
            attr: {
                'clip-path': 'url(#clip0_2689_11971)',
                stroke: 'currentColor',
                'stroke-width': '1.2',
            },
            path: [
                {
                    attr: {
                        d: 'M13.592 3a8.375 8.375 0 00-7.336 4.31 8.394 8.394 0 00.208 8.51L4 21l5.175-2.467a8.388 8.388 0 0012.504-4.834 8.407 8.407 0 00-4.341-9.824A8.386 8.386 0 0013.592 3z',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                    },
                },
                {
                    attr: {
                        d: 'M15.4 15h-.6a1.2 1.2 0 01-1.2-1.2v-3a.6.6 0 00-.6-.6h-.6',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                    },
                },
                { attr: { d: 'M13.3 7.8a.3.3 0 110-.6M13.3 7.8a.3.3 0 100-.6' } },
            ],
        },
        defs: {
            clipPath: {
                attr: { id: 'clip0_2689_11971' },
                path: {
                    attr: {
                        fill: 'currentColor',
                        transform: 'translate(.764)',
                        d: 'M0 0h24v24H0z',
                    },
                },
            },
        },
    },
};
